import React, { FC } from 'react'

import { IconVodafoneStoreProps } from './IconVodafoneStore.types'
import * as Styled from './styles/IconVodafoneStore.style'

import { nonThemeableRules } from '../../ruleSet'

const IconVodafoneStore: FC<IconVodafoneStoreProps> = ({
  size = nonThemeableRules.defaultSize as number as IconVodafoneStoreProps['size'],
  isResponsive = false,
}: IconVodafoneStoreProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M8.863 19.3v20.75a3 3 0 0 0 3 3H40a3 3 0 0 0 3-3V9.613'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M14.885 42.473v-16.5a3 3 0 0 1 3-3H34a3 3 0 0 1 3 3v17'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M29.618 33.84h2.977' stroke='#E60000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M11.92 5.108H43v8.555c0 2.57-2 4.75-4.568 4.85a4.75 4.75 0 0 1-4.377-2.55.605.605 0 0 0-1.07 0 4.75 4.75 0 0 1-8.41-.015.606.606 0 0 0-1.072 0 4.75 4.75 0 0 1-8.398-.013.604.604 0 0 0-1.075 0A4.75 4.75 0 0 1 9.818 18.5h-.185a4.649 4.649 0 0 1-4.555-4.75c0-2.348 1.607-4.957 2.912-6.687a4.917 4.917 0 0 1 3.93-1.955v0Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconVodafoneStore
